import React from 'react'

const PageNotFound = () => {
  return (
    <>
      <h1>404</h1>
      <div>Page Not Found</div>
    </>
  )
}

export default PageNotFound